// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Google Play in-app updates (flexible flow). Android only, and optional even there:
 * `requireOptionalNativeModule` returns null on web and in builds made before this module
 * existed, so callers treat null as "no update support".
 */

import { requireOptionalNativeModule, type EventSubscription } from 'expo-modules-core';

export type InstallStatus =
  | 'PENDING'
  | 'DOWNLOADING'
  | 'DOWNLOADED'
  | 'INSTALLING'
  | 'INSTALLED'
  | 'FAILED'
  | 'CANCELED'
  | 'UNKNOWN';

export type AppUpdateInfo = {
  available: boolean;
  availableVersionCode: number;
  flexibleAllowed: boolean;
  installStatus: InstallStatus;
};

type PlayAppUpdateNativeModule = {
  checkAsync(): Promise<AppUpdateInfo>;
  startFlexibleAsync(): Promise<boolean>;
  completeAsync(): Promise<void>;
  addListener(event: 'onInstallStatus', listener: (event: { status: InstallStatus }) => void): EventSubscription;
};

export const PlayAppUpdate = requireOptionalNativeModule<PlayAppUpdateNativeModule>('PlayAppUpdate');
